import { render, staticRenderFns } from "./ManufacturerDistributorCreate.vue?vue&type=template&id=fd84071c&"
import script from "./ManufacturerDistributorCreate.vue?vue&type=script&lang=js&"
export * from "./ManufacturerDistributorCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports